<template>
  <!-- 限额分配记录 -->
  <div class="credit-assignment-record">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="CREDIT_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>
    <a-card>
      <table-view
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <template v-slot:amount="{ tableRow }">
          <span>{{ tableRow.amount | formatAmount }}</span>
        </template>

        <template v-slot:creditExposure="{ tableRow }">
          <span>{{ tableRow.creditExposure | formatAmount }}</span>
        </template>

        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="STATUS_OBJ[tableRow.status].color"
            style="width: 70px; text-align: center;"
          >
            {{ STATUS_OBJ[tableRow.status].label }}
          </a-tag>
        </template>

        <template v-slot:action="{ tableRow }">
          <a-popconfirm
            v-if="tableRow.status === 1"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleRevoke(tableRow)"
          >
            <template slot="title">
              <p>确认取消授信？</p>
              <p>取消后，子公司被分配的额度加回母公司额度</p>
            </template>
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a-button type="link" size="small">
              取消授信
            </a-button>
          </a-popconfirm>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { CREDIT_SEARCH_SCHEMA } from './schema'
import { CREDIT_TYPE_OBJ } from '../credit-approval/const'
import { STATUS_OBJ, ALLOCATE_TYPE_OBJ } from './const'
import { getRecordList, cancelAllocate } from './api'
import { formatParamDate } from 'utils/util'
import { ERR_OK } from 'config/index'

export default {
  name: 'credit-assignment-record',
  data() {
    const initSearchForm = {
      parentCode: '',
      childCode: '',
      createTimeStart: '',
      createTimeEnd: '',
      indateStart: '',
      indateEnd: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      CREDIT_SEARCH_SCHEMA,
      STATUS_OBJ,
      tableLoading: false,
      initSearchForm,
      searchForm,
      tableData: [],
      columns: [
        {
          title: '授信编号',
          dataIndex: 'id',
          width: 220,
        },
        {
          title: '授信企业(母公司)',
          dataIndex: 'parentName',
        },
        {
          title: '子公司',
          dataIndex: 'childName',
          width: 220,
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          width: 100,
        },
        {
          title: '授信类型',
          customRender: (text, record) => {
            return CREDIT_TYPE_OBJ[record.type]
          },
          width: 150,
        },
        {
          title: '授信额度',
          scopedSlots: { customRender: 'amount' },
          width: 150,
        },
        {
          title: '母公司信用限额敞口',
          scopedSlots: { customRender: 'creditExposure' },
          width: 160,
        },
        {
          title: '有效开始时间',
          dataIndex: 'indicateStart',
          width: 120,
        },
        {
          title: '有效结束时间',
          dataIndex: 'indicateEnd',
          width: 120,
        },
        {
          title: '上传方式',
          customRender: (text, record) => {
            return ALLOCATE_TYPE_OBJ[record.allocateType]
          },
          width: 100,
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          width: 120,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 1800 },
    }
  },
  mounted() {
    this._getRecordList(this.initSearchForm)
  },
  methods: {
    async _getRecordList(searchForm) {
      if (this.tableLoading) {
        return
      }
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getRecordList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      data = formatParamDate(
        data,
        data.createTimeRange,
        'createTimeStart',
        'createTimeEnd',
      )
      data = formatParamDate(data, data.indateRange, 'indateStart', 'indateEnd')
      delete data.createTimeRange
      delete data.indateRange
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getRecordList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getRecordList(this.searchForm)
    },
    // 取消授信
    async handleRevoke(row) {
      const id = row.id
      try {
        const { code, message } = await cancelAllocate(id)
        if (code == ERR_OK) {
          this.$notification.success({
            message: '提示',
            description: message,
          })
          this._getRecordList(this.searchForm)
        } else if (code == '0001') {
          this.$notification.error({
            message: '提示',
            description: message,
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
